import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ComingSoon from '../../views/error/coming-soon';
import NotFound from '../../views/error/not-found';
import Account from '../../views/pages/account';
import AccountTransfer from '../../views/pages/account-transfer';
import Asset from '../../views/pages/asset';
import Bridge from '../../views/pages/bridge';
import Changelog from '../../views/pages/changelog';
import ClaimToken from '../../views/pages/claim-token';
import CraftResult from '../../views/pages/craft-result';
import CustomWallet from '../../views/pages/custom-wallet';
import Feedback from '../../views/pages/feedback';
import InitWallet from '../../views/pages/init-wallet';
import ManageTokens from '../../views/pages/manage-tokens';
import Market from '../../views/pages/market';
import MyAssets from '../../views/pages/my-assets';
import MyAssetsFlex from '../../views/pages/my-assets-flex';
import PaymentSuccess from '../../views/pages/payment-success';
import PendingBurn from '../../views/pages/pending-burn';
import PendingBurns from '../../views/pages/pending-burns';
import PendingUse from '../../views/pages/pending-use';
import PendingUses from '../../views/pages/pending-uses';
import MarketProduct from '../../views/pages/product';
import ResetPassword from '../../views/pages/reset-password';
import Root from '../../views/pages/root';
import Sandbox from '../../views/pages/sandbox';
import Shop from '../../views/pages/shop';
import ShopSerie from '../../views/pages/shop-serie';
import SignIn from '../../views/pages/sign-in';
import SignInJwt from '../../views/pages/sign-in-jwt';
import SignUp from '../../views/pages/sign-up';
import Staking from '../../views/pages/staking';
import StakingCreate from '../../views/pages/staking-create';
import StakingExtend from '../../views/pages/staking-extend';
import StakingFill from '../../views/pages/staking-fill';
import TransferAssetsMPC from '../../views/pages/transfer-assets-mpc';
import VipProgram from '../../views/pages/vip-program';
import Page from '../page';
import { RoutePath } from './config';
var routes = [
    {
        component: _jsx(Root, {}),
        path: RoutePath.ROOT,
        pageKey: 'root',
    },
    {
        component: _jsx(ComingSoon, {}),
        path: RoutePath.COMING_SOON,
        pageKey: 'coming-soon',
    },
    {
        component: _jsx(SignIn, {}),
        path: RoutePath.SIGN_IN,
        pageKey: 'sign-in',
    },
    {
        component: _jsx(SignInJwt, {}),
        path: RoutePath.SIGN_IN_JWT,
        pageKey: 'sign-in',
    },
    {
        component: _jsx(SignUp, {}),
        path: RoutePath.SIGN_UP,
        pageKey: 'sign-up',
    },
    {
        component: _jsx(ResetPassword, {}),
        path: RoutePath.RESET_PASSWORD,
        pageKey: 'reset-password',
    },
    {
        component: _jsx(Account, {}),
        path: RoutePath.ACCOUNT,
        pageKey: 'account',
    },
    {
        component: _jsx(AccountTransfer, {}),
        path: RoutePath.ACCOUNT_TRANSFER,
        pageKey: 'account',
    },
    {
        component: _jsx(InitWallet, {}),
        path: RoutePath.INIT_WALLET,
        pageKey: 'init-wallet',
    },
    {
        component: _jsx(TransferAssetsMPC, {}),
        path: RoutePath.TRANSFER_ASSETS_MPC,
        pageKey: 'transfer-assets',
    },
    {
        component: _jsx(CustomWallet, {}),
        path: RoutePath.CUSTOM_WALLET,
        pageKey: 'custom-wallet',
    },
    {
        component: _jsx(Shop, {}),
        path: RoutePath.SHOP,
        pageKey: 'shop',
    },
    {
        component: _jsx(ShopSerie, {}),
        path: RoutePath.SHOP_SERIE,
        pageKey: 'shop-serie',
    },
    {
        component: _jsx(Bridge, {}),
        path: RoutePath.BRIDGE,
        pageKey: 'bridge',
    },
    {
        component: _jsx(Market, {}),
        path: RoutePath.MARKET,
        pageKey: 'market',
    },
    {
        component: _jsx(MarketProduct, {}),
        path: RoutePath.PRODUCT,
        pageKey: 'product',
    },
    {
        component: _jsx(Asset, {}),
        path: RoutePath.ASSET,
        pageKey: 'asset',
    },
    {
        component: _jsx(MyAssets, {}),
        path: RoutePath.MY_ASSETS,
        pageKey: 'my-assets',
    },
    {
        component: _jsx(MyAssetsFlex, {}),
        path: RoutePath.MY_ASSETS_FLEX,
        pageKey: 'my-assets-flex',
    },
    {
        component: _jsx(ManageTokens, {}),
        path: RoutePath.MANAGE_TOKENS,
        pageKey: 'manage-tokens',
    },
    {
        component: _jsx(VipProgram, {}),
        path: RoutePath.VIP_PROGRAM,
        pageKey: 'vip-program',
    },
    {
        component: _jsx(Staking, {}),
        path: RoutePath.STAKING,
        pageKey: 'staking',
    },
    {
        component: _jsx(StakingCreate, {}),
        path: RoutePath.STAKING_CREATE,
        pageKey: 'staking-create',
    },
    {
        component: _jsx(StakingExtend, {}),
        path: RoutePath.STAKING_EXTEND,
        pageKey: 'staking-extend',
    },
    {
        component: _jsx(StakingFill, {}),
        path: RoutePath.STAKING_FILL,
        pageKey: 'staking-fill',
    },
    {
        component: _jsx(PendingBurns, {}),
        path: RoutePath.PENDING_BURNS,
        pageKey: 'pending-burns',
    },
    {
        component: _jsx(PendingBurn, {}),
        path: RoutePath.PENDING_BURN,
        pageKey: 'pending-burn',
    },
    {
        component: _jsx(PendingUses, {}),
        path: RoutePath.PENDING_USES,
        pageKey: 'pending-uses',
    },
    {
        component: _jsx(PendingUse, {}),
        path: RoutePath.PENDING_USE,
        pageKey: 'pending-use',
    },
    {
        component: _jsx(StakingFill, {}),
        path: RoutePath.STAKING_FILL,
        pageKey: 'staking-fill',
    },
    {
        component: _jsx(Changelog, {}),
        path: RoutePath.CHANGELOG,
        pageKey: 'changelog',
    },
    {
        component: _jsx(Feedback, {}),
        path: RoutePath.FEEDBACK,
        pageKey: 'feedback',
    },
    {
        component: _jsx(PaymentSuccess, {}),
        path: RoutePath.PAYMENT_SUCCESS,
        pageKey: 'payment-success',
    },
    {
        component: _jsx(ClaimToken, {}),
        path: RoutePath.CLAIM_TOKEN,
        pageKey: 'claim-token',
    },
    {
        component: _jsx(CraftResult, {}),
        path: RoutePath.CRAFT_RESULT,
        pageKey: 'craft-result',
    },
    {
        component: _jsx(Sandbox, {}),
        path: RoutePath.SANDBOX,
        pageKey: 'sandbox',
    },
];
export default function BrowserRoutes() {
    return (_jsxs(Routes, { children: [routes.map(function (_a) {
                var component = _a.component, path = _a.path, pageKey = _a.pageKey;
                return (_jsx(Route, { element: _jsx(Page, { children: component, pageKey: pageKey }), path: path }, path));
            }), _jsx(Route, { element: _jsx(Page, { children: _jsx(NotFound, {}), pageKey: "not-found" }), path: "*" })] }));
}
